import { useState } from 'react';
import PropTypes from 'prop-types';

import {
  ListItem,
  Accordion,
  Typography,
  AccordionSummary,
  AccordionDetails,
} from '@mui/material';

import useResponsiveScreen from 'src/hooks/useResponsiveScreen';

import Iconify from '../iconify';

export default function AccordionSection({ title, children, defaultExpanded = true }) {
  const { isSmallScreen } = useResponsiveScreen();
  const [expanded, setExpanded] = useState(defaultExpanded);
  const handleChange = (event, isExpanded) => {
    setExpanded(isExpanded);
  };
  return (
    <ListItem
      sx={{
        padding: 0,
        marginY: 1,
        borderRadius: '20px',
      }}
      alignItems="flex-start"
    >
      <Accordion
        onChange={handleChange}
        expanded={expanded}
        sx={{ width: '100%', py: 0.75, borderRadius: '20px' }}
      >
        <AccordionSummary
          expandIcon={<Iconify icon="ooui:expand" width={isSmallScreen ? 10 : 15} />}
          icon="material-symbols:percent"
          sx={{
            borderRadius: expanded ? '20px 20px 0 0' : '20px',
            transition: 'border-radius 0.4s ease, box-shadow 0.7s ease',
          }}
        >
          <Typography sx={{ fontWeight: 'bold' }}>{title}</Typography>
        </AccordionSummary>
        <AccordionDetails
          sx={{
            padding: 1,
            border: expanded ? '3px solid white' : '2px solid transparent',
            borderRadius: expanded && '0 0 20px 20px',
            transition: expanded && 'border-color 0.4s ease, border-width 0.4s ease',
            transitionDelay: expanded ? '0.2s' : '0s',
            backgroundColor: '#F9F8F8',
          }}
        >
          {children}
        </AccordionDetails>
      </Accordion>
    </ListItem>
  );
}

AccordionSection.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node,
  defaultExpanded: PropTypes.bool,
};
